import React from "react";
import { Form } from "react-bootstrap";
import { BsSun, BsMoon } from "react-icons/bs";

const ThemeToggle = ({ isDark, onToggle }) => {
  return (
    <Form.Check
      type="switch"
      id="theme-switch"
      label={isDark ? <BsMoon className="ms-2" /> : <BsSun className="ms-2" />}
      checked={isDark}
      onChange={onToggle}
      className="d-flex align-items-center"
    />
  );
};

export default ThemeToggle;
